import { useMemo } from 'react'
import { isPendingAnswerableStagedAction } from '@renderer/chat/integrations/answerable'
import { useVisibleStagedActions, type StagedAction } from '../../hooks/use-staged-actions'
import { orderStagedActionsChronologically } from '../chat-output-view/chat-output'

/**
 * This conversation's unanswered AskUserQuestion / AskUserFeedback actions,
 * oldest first. The first one is what the Chat View hoists into its floating
 * bar and tints its glow with, so both read the same ordering.
 */
export function useConversationPendingAnswerables(chatId: string | undefined): Array<StagedAction> {
  const { allActions } = useVisibleStagedActions()
  return useMemo(() => {
    if (!chatId) return []
    return orderStagedActionsChronologically(
      allActions.filter((action) => action.conversationId === chatId && isPendingAnswerableStagedAction(action)),
    )
  }, [chatId, allActions])
}
